import { API_BASE_URL } from "../config/apiConfig";

export async function login(email, password) {
  const res = await fetch(`${API_BASE_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await res.json();

  if (!res.ok) {
    // backend devuelve { message: "...", errors?: {} }
    throw new Error(data.message || "Credenciales inválidas");
  }

  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));

  return data;
}

export async function register(name, email, password, password_confirmation) {
  const res = await fetch(`${API_BASE_URL}/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ name, email, password, password_confirmation }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error en el registro");
  }

  return data;
}

export async function changePassword(current_password, password, password_confirmation) {
  const token = getToken();
  const res = await fetch(`${API_BASE_URL}/change-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ current_password, password, password_confirmation }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error al cambiar la contraseña");
  }

  return data;
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}

export function getToken() {
  return localStorage.getItem("token");
}

export function getCurrentUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

export function isAuthenticated() {
  return Boolean(getToken());
}
